import React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import {ArrowBack, Close} from '@mui/icons-material';
import {theme} from '../../Theme';
import {makeStyles} from '@mui/styles';
import useScreenWidth from '../../hooks/useScreenWidth';
import BidmiiLinearProgress from '../../modules/BidmiiCustomLoader/BidmiiLinearProgress';
import {Breakpoint} from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children?: ReactNode; direction: "up"; ref... Remove this comment to see the full error message
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDialog-paper': {
      width: '100%',
      marginLeft: window.outerWidth > 600 ? '4px !important' : 0,
      marginRight: window.outerWidth > 600 ? '4px !important' : 0,
    },
  },
}));

interface IProps {
  children: any;
  open: boolean;
  scroll?: boolean;
  loading?: boolean;
  fullScreen?: boolean;
  hideCloseButton?: boolean;
  onClose?: (event?: any, reason?: any) => void;
  onClickBackArrow?: () => void;
  secondaryAction?: any;
  primaryAction?: any;
  maxWidth?: Breakpoint;
}

export default function StandardDialog(props: IProps) {
  const classes = useStyles();
  const width = useScreenWidth();

  return (
    <Dialog
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'ForwardRefExoticComponent<RefAttributes<unkn... Remove this comment to see the full error message
      TransitionComponent={Transition}
      open={props.open}
      fullScreen={props.fullScreen || width < 600}
      fullWidth
      maxWidth={props.maxWidth || 'xs'}
      className={classes.root}
      PaperProps={{
        style: {
          borderRadius: width > 600 ? 10 : 0,
          backgroundColor: theme.palette.secondary.main,
          overflowX: 'hidden',
          overflowY: 'hidden',
        },
      }}>
      {props.loading ? <BidmiiLinearProgress /> : <div style={{height: 5}} />}

      <Box
        p={width > 600 ? 1 : 0}
        style={{
          borderRadius: window.outerWidth > 600 ? 10 : 0,
          backgroundColor: theme.palette.secondary.main,
          overflowX: 'hidden',
          overflowY: props.scroll ? 'scroll' : 'hidden',
          maxHeight: props.scroll && width > 600 ? '80vh' : '100vh',
        }}>
        {/* BACK AND CLOSE BUTTONS */}
        <Grid
          mt={width > 600 ? -1 : 0}
          mb={props.onClickBackArrow ? -0.5 : -2}
          container
          justifyContent="space-between"
          alignItems="center">
          {props.onClickBackArrow ? (
            <IconButton onClick={props.onClickBackArrow} size="large">
              <ArrowBack style={{color: theme.palette.gray.text}} />
            </IconButton>
          ) : (
            <div />
          )}
          {!props.hideCloseButton ? (
            <IconButton onClick={props.onClose} size="large">
              <Close style={{color: theme.palette.gray.text}} />
            </IconButton>
          ) : (
            <div style={{height: 32}} />
          )}
        </Grid>

        <Box mx={2}>
          {props.children}

          {/* FOOTER ACTION BUTTONS */}
          <Grid
            my={props.secondaryAction && props.primaryAction ? 2.5 : 1.5}
            container
            justifyContent="space-between"
            alignItems="center">
            {props.secondaryAction ?? <div />}
            {props.primaryAction ?? <div />}
          </Grid>
        </Box>
      </Box>
    </Dialog>
  );
}
